import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IPortMySuffix } from 'src/app/shared/model/port-my-suffix.model';
import { StateStorageService } from 'src/app/core';

type EntityResponseType = HttpResponse<IPortMySuffix>;
type EntityArrayResponseType = HttpResponse<IPortMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class PortMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/ports';
    private resourceUrlView = SERVER_API_URL + 'api/ports/view';

    private resourceUrlByAsscociation = SERVER_API_URL + 'api/ports/byAccociation';
    private unassignedPortResourceUrl = SERVER_API_URL + 'api/ports/un-assigned';
    private allPortResourceUrl = SERVER_API_URL + 'api/ports/all';
    private allPortwithLimiteddataResourceUrl = SERVER_API_URL + 'api/ports/all/limitedData';

    constructor(private http: HttpClient,
        private stateStorageService: StateStorageService,
        ) {}

    create(port: IPortMySuffix): Observable<EntityResponseType> {
        return this.http.post<IPortMySuffix>(this.resourceUrl, port, { observe: 'response' });
    }

    update(port: IPortMySuffix): Observable<EntityResponseType> {
        return this.http.put<IPortMySuffix>(this.resourceUrl, port, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IPortMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPortMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    queryUnAssignedPorts(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPortMySuffix[]>(this.unassignedPortResourceUrl, { params: options, observe: 'response' });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPortMySuffix[]>(this.allPortResourceUrl, { params: options, observe: 'response' });
    }
    getAllPorts(req?: any): Observable<EntityArrayResponseType> {
        console.log('getAllPorts');

        const options = createRequestOption(req);
        return this.http.get<any[]>(this.allPortwithLimiteddataResourceUrl, { params: options, observe: 'response' });
    }
    getPortsByAssociation(id: Number): Observable<HttpResponse<any[]>> {
        return this.http.get<any[]>(`${this.resourceUrlByAsscociation}/${id}`, { observe: 'response' });
    }
    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IPortMySuffix>(`${this.resourceUrlView}/${id}`, { observe: 'response' });
    }
    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IPortMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }
    getAllSubscribePortsAndStoreInStorage(req?: any){
        this.getAllPorts(req).subscribe(res => {
            let response = res.body;
            if(response){
                response = response.map(port=>{
                    port.name = port.name +" ( "+port['countryDTO']['name']+" )";
                    return port;
                });
                this.stateStorageService.storePorts(response);
            }
        });
    }
}
